<div id="user" [ngClass]="{'selected': user.id === selectedUser?.id}" class="d-flex align-items-center h-100"
  style="cursor: pointer;" (click)="onShowUser(user)">
  <div style="position: relative;">
    <div *ngIf="user.profilePicture" class="rounded-circle elevation-2 profile-picture user-icon"
      [style.background-image]="'url(' + user.profilePicture.path + ')'">
    </div>
    <i class='bx bx-user user-icon'></i>
    <div *ngIf="user.onlineColor" class="circle" [ngStyle]="{'background-color':user.onlineColor}"></div>
  </div>
  <p style="font-size: .9rem;">{{user?.name}}</p>
</div>